import { BPI } from '../types'

export const bpiData: BPI[] = [
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1001,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1002,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1003,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1004,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1005,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1006,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1007,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1008,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1009,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1010,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1020,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1021,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1022,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1023,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1025,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1026,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1027,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1028,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1029,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1030,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1031,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1032,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1033,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1034,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1035,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1036,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1037,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1038,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1039,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1040,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1041,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1042,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1043,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1044,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1045,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1046,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1100,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1101,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1105,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1106,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1107,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1108,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1109,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1110,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1112,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1113,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1114,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1115,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1116,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1117,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1118,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1119,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1120,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1121,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1122,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1123,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1124,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1125,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1126,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1127,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1128,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1129,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1130,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1131,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1132,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1133,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1134,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1135,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1136,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1137,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1138,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1139,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1140,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1141,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1142,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1143,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1144,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1145,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1146,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1147,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1148,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1149,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1150,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1151,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1152,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1153,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1154,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1155,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1156,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1157,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1158,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1159,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1160,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1161,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1162,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1163,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1164,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1165,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1166,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1167,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1168,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1169,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1170,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1171,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1172,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1173,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1174,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1175,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1176,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1177,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1178,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1179,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1180,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1181,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1182,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1183,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1184,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1185,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1186,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1187,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1188,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1189,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1190,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1191,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1192,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1193,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1194,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1195,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1196,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1197,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1198,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1199,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1201,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1202,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1203,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1205,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1207,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1208,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1209,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1210,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1211,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1212,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1213,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1214,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1215,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1216,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1217,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1218,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1219,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1220,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1221,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1222,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1223,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1224,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1225,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1226,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1227,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1228,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1229,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1230,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1231,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1232,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1233,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1234,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1235,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1236,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1237,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1238,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1239,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1240,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1291,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1292,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1293,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1294,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1295,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1296,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1297,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1298,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1299,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1300,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1314,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1335,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1340,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1350,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1355,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1360,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1401,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1419,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1420,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1422,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1423,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1424,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1425,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1426,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1427,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1428,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1429,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1430,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1435,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1440,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1441,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1445,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1450,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 1455,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1460,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1465,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1466,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1470,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1475,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1476,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1480,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1481,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1484,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1485,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1490,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1493,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1495,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 1499,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 1515,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1560,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1565,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1570,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1585,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1590,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1595,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1597,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1602,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1630,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1635,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1639,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1640,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1655,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1658,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1660,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1670,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1675,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1680,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1685,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1700,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1710,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1715,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1730,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1740,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1741,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1750,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1755,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1765,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1771,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1781,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1790,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1800,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1805,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1811,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1819,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1825,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1830,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1831,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1835,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1851,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1860,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1871,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1875,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1885,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1888,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1890,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 1891,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2000,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2001,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2002,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2004,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2006,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2007,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2008,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2009,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2010,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2011,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2012,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2013,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2015,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2016,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2017,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2018,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2019,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2020,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2021,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2022,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2023,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2024,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2025,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2026,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2027,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2028,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2029,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2030,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2031,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2032,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2033,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2034,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2035,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2036,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2037,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2038,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2039,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2040,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2041,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2042,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2043,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2044,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2045,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2046,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2047,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2048,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2049,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2050,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2052,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2055,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2057,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2058,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2059,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2060,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2061,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2062,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2063,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2064,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2065,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2066,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2067,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2068,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2069,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2070,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2071,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2072,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2073,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2074,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2075,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2076,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2077,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2079,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2080,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2081,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2082,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2083,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2084,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2085,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2086,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2087,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2088,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2089,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2090,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2091,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2092,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2093,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2094,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2095,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2096,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2097,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2099,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2100,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2101,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2102,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2103,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2104,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2105,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2106,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2107,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2108,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2109,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2110,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2111,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2112,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2113,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2114,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2115,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2116,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2117,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2118,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2119,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2120,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2121,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2122,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2123,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2124,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2125,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2126,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2127,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2128,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2129,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2130,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2131,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2132,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2133,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2134,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2135,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2136,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2137,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2138,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2139,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2140,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2141,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2142,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2143,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2144,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2145,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2146,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2147,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2148,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2150,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2151,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2152,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2153,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2154,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2155,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2156,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2157,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2158,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2159,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2160,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2161,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2162,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2163,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2164,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2165,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2166,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2167,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2168,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2170,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2171,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2172,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2173,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2174,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2175,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2176,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2177,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2178,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2179,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2190,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2191,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2192,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2193,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2194,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2195,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2196,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2197,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2198,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2199,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2200,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2203,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2204,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2205,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2206,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2207,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2208,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2209,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2210,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2211,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2212,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2213,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2214,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2216,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2217,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2218,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2219,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2220,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2221,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2222,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2223,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2224,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2225,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2226,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2227,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2228,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2229,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2230,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2231,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2232,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2233,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2234,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2250,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2251,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2252,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2256,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2257,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2258,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2259,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2260,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2261,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2262,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2263,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2264,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2265,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2267,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2278,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2280,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2281,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2282,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2283,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2284,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2285,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2286,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2287,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2289,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2290,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2291,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2292,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2293,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2294,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2295,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2296,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2297,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2298,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2299,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2300,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2302,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2303,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2304,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2305,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2306,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2307,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2308,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2310,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2311,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2312,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2314,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2315,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2316,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2317,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2318,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2319,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2320,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2321,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2322,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2323,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2324,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2325,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2326,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2327,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Muswellbrook',
    Postcode: 2328,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Muswellbrook',
    Postcode: 2329,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2330,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2330,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2331,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Muswellbrook',
    Postcode: 2333,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Singleton',
    Postcode: 2334,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2335,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Muswellbrook',
    Postcode: 2336,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2337,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2338,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2339,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2340,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2341,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2342,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2343,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2344,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2345,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2346,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2347,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Armidale',
    Postcode: 2350,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Armidale',
    Postcode: 2351,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2352,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2353,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2354,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2355,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2356,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2357,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Armidale',
    Postcode: 2358,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Inverell',
    Postcode: 2359,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Inverell',
    Postcode: 2360,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2361,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Glen Innes',
    Postcode: 2365,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Inverell',
    Postcode: 2369,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Glen Innes',
    Postcode: 2369,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Glen Innes',
    Postcode: 2370,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2371,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2372,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tamworth',
    Postcode: 2379,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Gunnedah',
    Postcode: 2380,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Gunnedah',
    Postcode: 2381,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2382,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2386,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2387,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2388,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2390,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2395,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2396,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2397,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2398,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Narrabri',
    Postcode: 2399,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2400,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2401,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2402,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2403,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2404,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2405,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2406,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2408,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2409,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 2410,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2411,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2415,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2420,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Newcastle',
    Postcode: 2421,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2422,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2423,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2424,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Forster',
    Postcode: 2425,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2426,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2427,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Forster',
    Postcode: 2428,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2429,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2430,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Kempsey',
    Postcode: 2431,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Port Macquarie',
    Postcode: 2439,
    BPI: 1.07,
  },
  {
    'Nearest Major City': 'Armidale',
    Postcode: 2440,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Port Macquarie',
    Postcode: 2441,
    BPI: 1.07,
  },
  {
    'Nearest Major City': 'Kempsey',
    Postcode: 2442,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Taree',
    Postcode: 2443,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Port Macquarie',
    Postcode: 2444,
    BPI: 1.07,
  },
  {
    'Nearest Major City': 'Port Macquarie',
    Postcode: 2445,
    BPI: 1.07,
  },
  {
    'Nearest Major City': 'Port Macquarie',
    Postcode: 2446,
    BPI: 1.07,
  },
  {
    'Nearest Major City': 'Kempsey',
    Postcode: 2447,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Kempsey',
    Postcode: 2448,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Kempsey',
    Postcode: 2449,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Coffs Harbour',
    Postcode: 2450,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Coffs Harbour',
    Postcode: 2452,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Armidale',
    Postcode: 2453,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Coffs Harbour',
    Postcode: 2454,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Coffs Harbour',
    Postcode: 2455,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Coffs Harbour',
    Postcode: 2456,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Grafton',
    Postcode: 2460,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Wooll',
    Postcode: 2462,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Grafton',
    Postcode: 2463,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Grafton',
    Postcode: 2464,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Grafton',
    Postcode: 2465,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Grafton',
    Postcode: 2466,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2469,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2470,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2471,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2472,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2473,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2474,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2475,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2476,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2477,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2478,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2479,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2480,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2481,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Lismore',
    Postcode: 2482,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2483,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Cape Byron',
    Postcode: 2484,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2485,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2486,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2487,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2488,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2489,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Tweed Heads',
    Postcode: 2490,
    BPI: 1.04,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2500,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2502,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2505,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2506,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2508,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2515,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2516,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2517,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2518,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2519,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2520,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2522,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2525,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2526,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2527,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2528,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2529,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2530,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2533,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2534,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2535,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2536,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2537,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2538,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2539,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2540,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2541,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2545,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2546,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2548,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2549,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2550,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2551,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2555,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2556,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2557,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2558,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2559,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2560,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2563,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2564,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2565,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2566,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2567,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2568,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2569,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2570,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2571,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2572,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2573,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2574,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2575,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2576,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2577,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2578,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2579,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Goulburn',
    Postcode: 2580,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Queanbeyan',
    Postcode: 2581,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Yass',
    Postcode: 2582,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Bathurst',
    Postcode: 2583,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Yass',
    Postcode: 2584,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Yass',
    Postcode: 2585,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Young',
    Postcode: 2586,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Young',
    Postcode: 2587,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2588,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2590,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2594,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Canberra',
    Postcode: 2611,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Canberra',
    Postcode: 2618,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Queanbeyan',
    Postcode: 2619,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2620,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Queanbeyan',
    Postcode: 2621,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Wollongong',
    Postcode: 2622,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Queanbeyan',
    Postcode: 2623,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Jindabyne',
    Postcode: 2624,
    BPI: 1.19,
  },
  {
    'Nearest Major City': 'Thredbo',
    Postcode: 2625,
    BPI: 1.25,
  },
  {
    'Nearest Major City': 'Thredbo',
    Postcode: 2626,
    BPI: 1.25,
  },
  {
    'Nearest Major City': 'Jindabyne',
    Postcode: 2627,
    BPI: 1.19,
  },
  {
    'Nearest Major City': 'Thredbo',
    Postcode: 2627,
    BPI: 1.25,
  },
  {
    'Nearest Major City': 'Thredbo',
    Postcode: 2628,
    BPI: 1.25,
  },
  {
    'Nearest Major City': 'Jindabyne',
    Postcode: 2629,
    BPI: 1.19,
  },
  {
    'Nearest Major City': 'Thredbo',
    Postcode: 2630,
    BPI: 1.25,
  },
  {
    'Nearest Major City': 'Thredbo',
    Postcode: 2631,
    BPI: 1.25,
  },
  {
    'Nearest Major City': 'Batemans Bay',
    Postcode: 2632,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Bombala',
    Postcode: 2633,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'ALBURY',
    Postcode: 2640,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2641,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'ALBURY',
    Postcode: 2642,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2643,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'ALBURY',
    Postcode: 2644,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2645,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2646,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2647,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Broken Hill',
    Postcode: 2648,
    BPI: 1.26,
  },
  {
    'Nearest Major City': 'Tumbarumba',
    Postcode: 2649,
    BPI: 1.2,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2650,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2651,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2652,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Tumbarumba',
    Postcode: 2653,
    BPI: 1.2,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2655,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2656,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2658,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2659,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2660,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2661,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2663,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2665,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2666,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2668,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Hay',
    Postcode: 2669,
    BPI: 1.2,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2671,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Bathurst',
    Postcode: 2672,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2675,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2678,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2680,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2681,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2700,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2701,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2702,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2703,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2705,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2706,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2707,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2708,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2710,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2710,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2711,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2712,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2713,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2714,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Mildura',
    Postcode: 2715,
    BPI: 1.3,
  },
  {
    'Nearest Major City': 'Griffith',
    Postcode: 2716,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Broken Hill',
    Postcode: 2717,
    BPI: 1.26,
  },
  {
    'Nearest Major City': 'Tumbarumba',
    Postcode: 2720,
    BPI: 1.2,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2721,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2722,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2725,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Yass',
    Postcode: 2726,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2727,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2729,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Tumbarumba',
    Postcode: 2730,
    BPI: 1.2,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2731,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2732,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Albury',
    Postcode: 2733,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2734,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 2735,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Broken Hill',
    Postcode: 2736,
    BPI: 1.26,
  },
  {
    'Nearest Major City': 'Broken Hill',
    Postcode: 2737,
    BPI: 1.26,
  },
  {
    'Nearest Major City': 'Mildura',
    Postcode: 2738,
    BPI: 1.3,
  },
  {
    'Nearest Major City': 'Broken Hill',
    Postcode: 2739,
    BPI: 1.26,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2745,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2747,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2748,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2749,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2750,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2751,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2752,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2753,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2754,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2755,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2756,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2757,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2758,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2759,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2760,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2761,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2762,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2763,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2765,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2766,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2767,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2768,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2769,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2770,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2773,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2774,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Gosford',
    Postcode: 2775,
    BPI: 1.02,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2776,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2777,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2778,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2779,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2780,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2782,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2783,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2784,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2785,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2786,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 2787,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Bathurst',
    Postcode: 2790,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2791,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2792,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2793,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2794,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2795,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Bathurst',
    Postcode: 2795,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2797,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2798,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2799,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2800,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Young',
    Postcode: 2803,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2804,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2805,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2806,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2807,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2808,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2809,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2810,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2817,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2818,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2820,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2821,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2822,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2823,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2824,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Cobar',
    Postcode: 2825,
    BPI: 1.34,
  },
  {
    'Nearest Major City': 'Cobar',
    Postcode: 2826,
    BPI: 1.34,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2826,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2827,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2828,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2829,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2830,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2831,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Cobar',
    Postcode: 2832,
    BPI: 1.34,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 2833,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Cobar',
    Postcode: 2834,
    BPI: 1.34,
  },
  {
    'Nearest Major City': 'Cobar',
    Postcode: 2835,
    BPI: 1.34,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2836,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2838,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Bourke',
    Postcode: 2839,
    BPI: 1.28,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2840,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2842,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2843,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Mudgee',
    Postcode: 2844,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Lithgow',
    Postcode: 2845,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Lithgow',
    Postcode: 2846,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Lithgow',
    Postcode: 2847,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Mudgee',
    Postcode: 2848,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Mudgee',
    Postcode: 2849,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Mudgee',
    Postcode: 2850,
    BPI: 1.12,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2852,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2864,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2865,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2866,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2867,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2868,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2869,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Orange',
    Postcode: 2870,
    BPI: 1.05,
  },
  {
    'Nearest Major City': 'Forbes',
    Postcode: 2871,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2873,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Wagga Wagga',
    Postcode: 2874,
    BPI: 1.03,
  },
  {
    'Nearest Major City': 'Parkes',
    Postcode: 2875,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Parkes',
    Postcode: 2876,
    BPI: 1.1,
  },
  {
    'Nearest Major City': 'Dubbo',
    Postcode: 2877,
    BPI: 1.08,
  },
  {
    'Nearest Major City': 'Broken Hill',
    Postcode: 2878,
    BPI: 1.26,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2879,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Sydney',
    Postcode: 2880,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Mildura',
    Postcode: 3500,
    BPI: 1.3,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 3585,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 3586,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'Deniliquin',
    Postcode: 3644,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'ALBURY',
    Postcode: 3691,
    BPI: 1.01,
  },
  {
    'Nearest Major City': 'Bombala',
    Postcode: 3707,
    BPI: 1.15,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 4327,
    BPI: 1,
  },
  {
    'Nearest Major City': 'SYDNEY',
    Postcode: 4330,
    BPI: 1,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 4377,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 4380,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 4383,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Moree',
    Postcode: 4385,
    BPI: 1.13,
  },
  {
    'Nearest Major City': 'Tenterfield',
    Postcode: 4385,
    BPI: 1.13,
  },
]
